export default "__VITE_ASSET__CoZNwL9y__"